import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCheck3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShieldCheck3"><Path d="M8.75 12L10.9167 14.25L15.25 9.75M12 2L3.5 5.5V13C3.5 17.6944 7.30558 21.5 12 21.5C16.6944 21.5 20.5 17.6944 20.5 13V5.5L12 2Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShieldCheck3;
